import { CutleryIcon } from "./FilterIcons";

/**
 * Un raccourci, pas une affiche : le clic emmène directement sur la fiche de
 * l'espace qui sert à cet instant. La cible est calculée par l'appelant au
 * moment du clic, et non au rendu — la carte peut rester affichée plusieurs
 * jours sur un écran du campus.
 */
const Restauration = ({ onFindPlace }) => (
    <div className="restauration">
        <button
            type="button"
            className="resto-trigger"
            onClick={onFindPlace}
        >
            <CutleryIcon className="resto-trigger-icon" />
            <span>Pour me restaurer ou boire un verre ?</span>
        </button>
    </div>
);

export default Restauration;
